import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ListClinicResponseElement } from '../types/apiGeneratedTypes';

export interface ClinicsPageState {
  isClinicsLoading: boolean;
  appliedFilters: string[];
  isAddClinicModalOpened: boolean;
  clinicsList: ListClinicResponseElement[] | null;
  clinicDataToEdit: ListClinicResponseElement | null;
  clinicDataToView: ListClinicResponseElement | null;
  clinicsCount: number;
  limit: number;
  sortKey: string | null;
  sortOrder: 'asc' | 'desc';
}

export const initialState: ClinicsPageState = {
  appliedFilters: [],
  isAddClinicModalOpened: false,
  clinicsList: null,
  clinicsCount: 0,
  limit: 10,
  clinicDataToEdit: null,
  clinicDataToView: null,
  isClinicsLoading: false,
  sortKey: null,
  sortOrder: 'asc',
};

const clinicsPageSlice = createSlice({
  name: 'clinics',
  initialState,
  reducers: {
    changeModalVisibility(state, action: PayloadAction<boolean>) {
      state.isAddClinicModalOpened = action.payload;
    },
    setClinicsList(state, action: PayloadAction<ListClinicResponseElement[]>) {
      state.clinicsList = action.payload;
    },
    setClinicsCount(state, action: PayloadAction<number>) {
      state.clinicsCount = action.payload;
    },
    appendClinicsList(
      state,
      action: PayloadAction<ListClinicResponseElement[]>
    ) {
      if (!state.clinicsList) {
        state.clinicsList = action.payload;
      } else {
        state.clinicsList = [...state.clinicsList, ...action.payload];
      }
    },
    setClinicDataToEdit(
      state,
      action: PayloadAction<ListClinicResponseElement | null>
    ) {
      state.clinicDataToEdit = action.payload;
    },
    setClinicDataToView(
      state,
      action: PayloadAction<ListClinicResponseElement | null>
    ) {
      state.clinicDataToView = action.payload;
    },
    setIsClinicsLoading(state, action: PayloadAction<boolean>) {
      state.isClinicsLoading = action.payload;
    },
    setSorting(
      state,
      action: PayloadAction<{ key: string; order: 'asc' | 'desc' }>
    ) {
      state.sortKey = action.payload.key;
      state.sortOrder = action.payload.order;
    },
  },
});

export const {
  changeModalVisibility,
  setClinicsList,
  setClinicsCount,
  appendClinicsList,
  setClinicDataToEdit,
  setIsClinicsLoading,
  setClinicDataToView,
  setSorting,
} = clinicsPageSlice.actions;
export default clinicsPageSlice.reducer;
